/**
 *  开发完单页面组件请在这里注册
 *  前台根据权限编号去匹配相应组件
 *  开发时组件的name须与权限权限树的编号一致
 *  找不到匹配的组件将匹配默认组件common-grid.vue
 */
import customComponentsMap from '../custom/components/custom-components-register'

import Common from './grid/common-grid.vue'
import MenuManageTree from '../super-admin/menu-manage/menu-manage-tree.vue'
import RoleMenuManage from '../super-admin/menu-manage/role_menu_manage.vue'
import BaseCategoryManage from '../super-admin/base-category/sa-base-category-manage'
import SiteRoleMenu from '../site-admin/menu-manage/site_role_menu.vue'
import MenuIsActiveManage from '../super-admin/menu-manage/menu_is_active_manage.vue'
import SiteConfigManage from '../super-admin/site-manage/site-config-manage.vue'
import CacheClear from '../super-admin/cache/cache-clear.vue'
import Dashboard from './dashboard'
import ShowDeleteRecord from './record/show-delete-record'
import OperateRecordManage from './record/operate-record-manage'

// 把业务系统自定义的组件也获取到
const componentsMap = {...customComponentsMap}

const components = [
  Common, MenuManageTree, RoleMenuManage, BaseCategoryManage, MenuIsActiveManage, SiteConfigManage, CacheClear, SiteRoleMenu,
  Dashboard, ShowDeleteRecord, OperateRecordManage
]

for (let i = 0; i < components.length; i++) {
  componentsMap[components[i].name] = components[i]
}

export default componentsMap



// WEBPACK FOOTER //
// ./src/components/components-register.js